/**
 * router/routes/public.routes.ts
 * Top-level public routes — NOT nested under AppShell, render fullscreen.
 * Split out of router/index.ts (openspec/arquitectura/convencion-modulo.md §4).
 */
import type { RouteRecordRaw } from 'vue-router';

export const publicRoutes: RouteRecordRaw[] = [
  // --- Public routes (NOT nested under AppShell — render fullscreen) ---

  // FS-8.3: /login stays top-level.
  {
    path: '/login',
    name: 'login',
    component: () => import('../../views/LoginView.vue'),
    meta: { public: true },
  },

  // FS-8.6: /platform/login is also top-level, fullscreen, no shell (PC-1, design §3).
  {
    path: '/platform/login',
    name: 'platform-login',
    component: () => import('../../views/PlatformLoginView.vue'),
    meta: { public: true },
  },

  // Person alta stage 2 — the one-time link RRHH sends the new employee. No
  // shell; opens the same with or without a session.
  {
    path: '/alta/:token',
    name: 'public-onboarding',
    component: () => import('../../views/rrhh/PublicOnboardingView.vue'),
    meta: { anySession: true },
  },

  // Búsquedas asked through a requester's permanent link (2026-10-13). Same shape.
  {
    path: '/busqueda/:token',
    name: 'public-recruitment-request',
    component: () => import('../../views/rrhh/PublicRecruitmentRequestView.vue'),
    meta: { anySession: true },
  },
];
